import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {Box, Button, Card, CardHeader, Checkbox, Grid, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {},
  worksToDoRow : { backgroundColor: "#DDDDDD" },
  worksToDoCell : { color: "#888888" },
  completedWorksNeedsHourEntryRow : { backgroundColor: "#94F96E" },
  completedWorksNeedsHourEntryCell : { color: "black" }
}));

const Results = ({ className, worklists, ...rest }) => {
  const classes = useStyles();
  const [selectedWorkIds, setSelectedWorkIds] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const handleLimitChange = (event) => { setLimit(event.target.value); };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const worksToDoRowStyle = { backgroundColor: "#DDDDDD" };
  const completedWorksNeedsHourEntryCellStyle = { color: "black" };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CardHeader title="Works to do"></CardHeader>
        <Card className={clsx(classes.root, className)} {...rest}>
          <PerfectScrollbar>
            <Box minWidth={1050}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{width: "25%"}}>Work Description</TableCell>
                    <TableCell style={{width: "15%"}}>Start Date</TableCell>
                    <TableCell style={{width: "15%"}}>Work Hour</TableCell>
                    <TableCell style={{width: "25%"}}>Location</TableCell>
                    <TableCell style={{width: "20%"}}>Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {worklists.slice(0, 2).map((work) => (
                    <TableRow 
                        hover 
                        key={work.id} 
                        selected={selectedWorkIds.indexOf(work.id) !== -1}
                        className={clsx(classes.worksToDoRow, className)}>
                      <TableCell className={clsx(classes.worksToDoCell, className)}>{work.workdescription}</TableCell>
                      <TableCell className={clsx(classes.worksToDoCell, className)}>{moment(work.startedAt).format('DD/MM/YYYY')}</TableCell>
                      <TableCell className={clsx(classes.worksToDoCell, className)}>{work.workhour}</TableCell>
                      <TableCell className={clsx(classes.worksToDoCell, className)}>{`${work.address.city}, ${work.address.state}, ${work.address.country}`}</TableCell>
                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCellStyle, className)}><Button>View</Button></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
          <TablePagination component="div" 
            count={worklists.length}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[10, 50, 100]} />
        </Card>
      </Grid>

      <Grid item xs={12}>
      <CardHeader title="Completed works needs hour entry"></CardHeader>
        <Card className={clsx(classes.root, className)} {...rest}>
          <PerfectScrollbar>
            <Box minWidth={1050}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{width: "25%"}}>Work Description</TableCell>
                    <TableCell style={{width: "15%"}}>Start Date</TableCell>
                    <TableCell style={{width: "15%"}}>Work Hour</TableCell>
                    <TableCell style={{width: "25%"}}>Location</TableCell>
                    <TableCell style={{width: "20%"}}>Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {worklists.slice(0, 2).map((work) => (
                    <TableRow 
                        hover 
                        key={work.id}
                        selected={selectedWorkIds.indexOf(work.id) !== -1}
                        className={clsx(classes.completedWorksNeedsHourEntryRow, className)}>
                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCell, className)}>{work.workdescription}</TableCell>
                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCell, className)}>{moment(work.startedAt).format('DD/MM/YYYY')}</TableCell>
                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCell, className)}>{work.workhour}</TableCell>
                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCell, className)}>{`${work.address.city}, ${work.address.state}, ${work.address.country}`}</TableCell>                  
                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCell, className)}><Button>View</Button><Button style ={{color:"green"}} variant="outlined" href="/app/work_hour">Enter Work Hour</Button></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
          <TablePagination component="div" 
            count={worklists.length}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[10, 50, 100]} />
        </Card>
      </Grid>

      <Grid item xs={12}>
      <CardHeader title="Completed works totally"></CardHeader>
        <Card className={clsx(classes.root, className)} {...rest}>
          <PerfectScrollbar>
            <Box minWidth={1050}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{width: "25%"}}>Work Description</TableCell>
                    <TableCell style={{width: "15%"}}>Start Date</TableCell>
                    <TableCell style={{width: "15%"}}>Work Hour</TableCell>
                    <TableCell style={{width: "25%"}}>Location</TableCell>
                    <TableCell style={{width: "20%"}}>Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {worklists.slice(0, 2).map((work) => (
                    <TableRow 
                        hover 
                        key={work.id} 
                        selected={selectedWorkIds.indexOf(work.id) !== -1}
                        className={clsx(classes.worksToDoRow, className)}>
                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCell, className)}>{work.workdescription}</TableCell>
                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCell, className)}>{moment(work.startedAt).format('DD/MM/YYYY')}</TableCell>
                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCell, className)}>{work.workhour}</TableCell>
                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCell, className)}>{`${work.address.city}, ${work.address.state}, ${work.address.country}`}</TableCell>                  
                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCell, className)}><Button>View</Button></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
          <TablePagination component="div" 
            count={worklists.length}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[10, 50, 100]} />
        </Card>
      </Grid>
    </Grid>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  worklists: PropTypes.array.isRequired
};

export default Results;
